"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsContext.default;
  }
});

var _useSecureDocumentsContext = _interopRequireDefault(require("./useSecureDocumentsContext"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IH0gZnJvbSAnLi91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0JztcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useSecureDocumentsContext/index.js
// module id = 1840
// module chunks = 0